module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJ2aWRlby1wbGF5LnN2Zz85YjczNzk1OGIxNjQ0YjQ2YjIzOTA0ZTUzYWZjYWM1MCI7"


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/video-play.svg
// module id = 529
// module chunks = 2